import moment from "moment";
import { observable, computed, toJS } from "mobx";

class ProfileLicenseStore {
	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this._provider = staticContext.provider;
		this._licenses =
			staticContext.credentials?.filter(
				(l) => l.category?.toLowerCase() === "license",
			) || [];
	}

	@observable _provider = [];
	@computed get provider() {
		return toJS(this._provider);
	}

	@observable _licenses = [];
	@computed get licenses() {
		return toJS(this._licenses);
	}

	@observable _certificates = [];
	@computed get certificates() {
		return toJS(this._certificates);
	}

	@computed get hasCertificates() {
		return this.certificates.length > 0;
	}

	@computed get hasLicenses() {
		return this.licenses.length > 0;
	}

	dateFormatString(date, format = "MM/DD/YYYY") {
		if (!date) return date;
		return moment.utc(date).format(format);
	}
}

export default ProfileLicenseStore;
